<template>
  <div :style="!noPadding ? 'padding-bottom: 92px' : ''">
    <div class="fixed-top bg-secondary-theme text-center border-bottom shadow-sm">
      <div class="container position-relative">
        <div class="d-block position-absolute" style="left: 0">
          <a href="javascript:" @click="voltar" class="btn text-theme" style="margin: 13px 6px 0">
            <svg xmlns="http://www.w3.org/2000/svg" class="topbar__back-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M15 18l-6-6 6-6"/>
            </svg>
          </a>
        </div>
      </div>
      <h1 class="font-weight-bold h6 mx-auto limite" style="margin: 22px 0; max-width: 65%">
        {{title}}
      </h1>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopBar',
  props: ['title', 'url', 'noPadding', 'goClick'],
  methods: {
    voltar(url) {
      if (this.goClick) {
        this.$emit('voltar');

      } else if (this.url) {
        this.$router.push(this.url);

      } else {
        this.$router.go(-1);
      }
    }
  }
}
</script>

<style scoped>
.topbar__back-icon {
  display: block;
}
</style>
